import {RowUnit} from "../../../../library/atomic/unit/RowUnit";
import {SpanText} from "../../../../library/atomic/text/SpanText";
import {SizeAttr} from "../../../../library/basic/size";
import {RowAttr} from "../../../../library/basic/compose";
import {Input, Select} from "antd";
import {WindowParam} from "../../../../library/context/WindowContext";

export function InputString(wp: WindowParam, desc: string, value: string, setValue: (v: string) => void,
                            placeholder: string = "", width: string = "180px", height: string = "36px",
                            innerMarginRight: string = "12px", outerMarginRight: string = "22px") {
    return (
        <RowUnit
            customStyleAttr={{
                "marginRight": outerMarginRight
            }}
            sizeAttr={new SizeAttr(wp, width, height)}>
            <SpanText customStyleAttr={Object.assign(
                RowAttr.getChildrenPositionObj(),
                {"marginRight": innerMarginRight, "whiteSpace": "nowrap"}
            )}>
                {desc}
            </SpanText>
            <Input
                defaultValue={""}
                style={RowAttr.getChildrenPositionObj()}
                value={value}
                onChange={(e) => {
                    let v = e.target.value
                    setValue(v)
                }}
                placeholder={placeholder}
            />
        </RowUnit>
    )
}

export function InputSelect(wp: WindowParam, desc: string, value: string, setValue: (v: string) => void,
                            options: {value: string, label: string}[],
                            width: string = "180px", selectWidth: string = "120px", height: string = "36px",
                            innerMarginRight: string = "12px", outerMarginRight: string = "22px") {
    return (
        <RowUnit
            customStyleAttr={{
                "marginRight": outerMarginRight
            }}
            sizeAttr={new SizeAttr(wp, width, height)}>
            <SpanText customStyleAttr={Object.assign(
                RowAttr.getChildrenPositionObj(),
                {"marginRight": innerMarginRight}
            )}>
                {desc}
            </SpanText>
            <Select
                defaultValue={value}
                value={value}
                style={Object.assign(RowAttr.getChildrenPositionObj(), {
                    "width": selectWidth
                })}
                onChange={(e) => {
                    setValue(e)
                }}
                options={options}
            />
        </RowUnit>
    )
}